import { UserStateType } from './types';

export const userInitialState: UserStateType = {
  data: null,
  loading: false,
  error: null,
};
